import { render, staticRenderFns } from "./ETG.vue?vue&type=template&id=e505f84e"
import script from "./ETG.vue?vue&type=script&lang=js"
export * from "./ETG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports